import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ReportFile from './ReportFile'
import {
  updateSelectedReportId,
  getReportFileData,
  handleOnCommentChange,
  handleOnCancelClick,
  handleOnSignatureClick,
  handleOnEsignClick,
  handleOnAllReportsClick,
  handleOnOutsidePopoverClick,
} from './module'
import { handleOnPatientClick } from '../../pages/PatientFile/module'
import { DATASOURCES } from '../../constants'
import { getDataSource } from '../../store/appReducer'

const mapActionCreators = {
  updateSelectedReportId,
  getReportFileData,
  handleOnCommentChange,
  handleOnCancelClick,
  handleOnSignatureClick,
  handleOnEsignClick,
  handleOnAllReportsClick,
  handleOnOutsidePopoverClick,
  handleOnPatientClick,
}

const mapStateToProps = state => ({
  dataIsFetching: state.reportFile.dataIsFetching,
  dataLastUpdated: state.reportFile.dataLastUpdated,
  authorizationType: state.auth.authorizationType,
  browser: state.app.browser,
  tempComment: state.reportFile.tempComment,
  comment: state.reportFile.comment,
  esignStep: state.reportFile.esignStep,
  selectedReportId: state.reportFile.selectedReportId,
  selectedPopover: state.reportFile.selectedPopover,
  singleReportPdf: getDataSource(state, DATASOURCES.SINGLE_REPORT_PDF),
  reports: getDataSource(state, DATASOURCES.REPORTS),
})

export default withRouter(connect(
  mapStateToProps,
  mapActionCreators
)(ReportFile))



// WEBPACK FOOTER //
// ./src/legacy/containers/ReportFile/container.js